import {
  Action,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { InjectionToken } from '@angular/core';
import { ServiceOrderReducer, ServiceOrderState } from '@root/platform/service-order/service-order-store/reducer';
import { ClientReducer, ClientState } from '@root/platform/service-order/new-client/client-store/reducer';
import { VehicleReducer, VehicleState } from '@root/platform/service-order/new-vehicle/vehicle-store/reducer';
import { SessionState, SessionUserReducer } from '@root/platform/users/users-store/reducer';


/**
 * Every reducer module's default export is the reducer function itself. In
 * addition, each module should export a type or interface that describes
 * the state of the reducer plus any selector functions. The `* as`
 * notation packages up all of the exports into a single object.
 */

/**
 * As mentioned, we treat each reducer like a table in a database. This means
 * our top level state interface is just a map of keys to inner state types.
 */
interface State {
  ServiceOrder: ServiceOrderState,
  Client: ClientState,
  Vehicle: VehicleState,
  Session: SessionState
}

export const ROOT_REDUCERS = new InjectionToken<
  ActionReducerMap<State, Action>
>('Root reducers token', {
  factory: () => ({
    ServiceOrder: ServiceOrderReducer.reducer,
    Client: ClientReducer.reducer,
    Vehicle: VehicleReducer.reducer,
    Session: SessionUserReducer.reducer
  }),
});
const getServiceOrderState = createFeatureSelector<ServiceOrderState>('ServiceOrder');
const getServiceOrder = createSelector(
  getServiceOrderState,
  ServiceOrderReducer.getServiceOrder
);
const getServiceOrderList = createSelector(
  getServiceOrderState,
  ServiceOrderReducer.getServiceOrderList
);
const getServiceOrderError = createSelector(
  getServiceOrderState,
  ServiceOrderReducer.getError
);
const getServiceOrderLoading = createSelector(
  getServiceOrderState,
  ServiceOrderReducer.getLoading
);
const getServiceOrderMessage = createSelector(
  getServiceOrderState,
  ServiceOrderReducer.getMessage
);
export const fromServiceOrder = {
  getState: getServiceOrderState,
  getError: getServiceOrderError,
  getLoading: getServiceOrderLoading,
  getMessage: getServiceOrderMessage,

  getServiceOrder,
  getServiceOrderList,

};

const getClientState = createFeatureSelector<ClientState>('Client');
const getClient = createSelector(
  getClientState,
  ClientReducer.getClient
);
const getClientList = createSelector(
  getClientState,
  ClientReducer.getClientList
);
const getDriver = createSelector(
  getClientState,
  ClientReducer.getDriver
);

const getClientError = createSelector(
  getClientState,
  ClientReducer.getError
);
const getClientLoading = createSelector(
  getClientState,
  ClientReducer.getLoading
);
const getClientMessage = createSelector(
  getClientState,
  ClientReducer.getMessage
);

export const fromClient = {
  getState: getClientState,
  getError: getClientError,
  getLoading: getClientLoading,
  getMessage: getClientMessage,
  getClientList,
  getClient,
  getDriver

};
const getSessionState = createFeatureSelector<SessionState>('Session');
const getUserSession= createSelector(
  getSessionState,
  SessionUserReducer.getUserSession
);

const getSessionError = createSelector(
  getSessionState,
  SessionUserReducer.getError
);
const getSessionLoading = createSelector(
  getSessionState,
  SessionUserReducer.getLoading
);
const getSessionMessage = createSelector(
  getSessionState,
  SessionUserReducer.getMessage
);
export const fromSession = {
  getState: getSessionState,
  getError: getSessionError,
  getLoading: getSessionLoading,
  getMessage: getSessionMessage,

  getUserSession
};

const getVehicleState = createFeatureSelector<VehicleState>('Vehicle');
const getVehicle = createSelector(
  getVehicleState,
  VehicleReducer.getVehicle
);
const getVehicleList = createSelector(
  getVehicleState,
  VehicleReducer.getVehicleList
);

const getVehicleError = createSelector(
  getVehicleState,
  VehicleReducer.getError
);
const getVehicleLoading = createSelector(
  getVehicleState,
  VehicleReducer.getLoading
);
const getVehicleMessage = createSelector(
  getVehicleState,
  VehicleReducer.getMessage
);
export const fromVehicle = {
  getState: getVehicleState,
  getError: getVehicleError,
  getLoading: getVehicleLoading,
  getMessage: getVehicleMessage,

  getVehicle,
  getVehicleList,

}
export { State };
